import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateLanguageSpecificationForm } from "../forms/CreateLanguageSpecificationForm";

export type CreateLanguageSpecificationButtonProps = ButtonProps;

export const CreateLanguageSpecificationButton: FunctionComponent<CreateLanguageSpecificationButtonProps> = (
    props: CreateLanguageSpecificationButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Add language specification"} onDismiss={closeAside}>
                <CreateLanguageSpecificationForm onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
